module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "claimDetail"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "main claim"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._m(0), _vm._v(" "), (_vm.obj.status == 1) ? _c('p', {
    staticClass: "status"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.obj.status == 2) ? _c('p', {
    staticClass: "status_success"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.obj.status == 3) ? _c('p', {
    staticClass: "status_failed"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.obj.status == 1) ? _c('div', {
    staticClass: "logo"
  }) : _vm._e(), _vm._v(" "), (_vm.obj.status == 2) ? _c('div', {
    staticClass: "logo_success"
  }) : _vm._e(), _vm._v(" "), (_vm.obj.status == 3) ? _c('div', {
    staticClass: "logo_failed"
  }) : _vm._e()])]), _vm._v(" "), (_vm.obj.status == 1) ? _c('div', {
    attrs: {
      "id": "claimPage"
    }
  }, [_c('p', {
    staticClass: "limit"
  }, [_vm._v("参保用户赔偿额度")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("索赔流程:"), _c('router-link', {
    attrs: {
      "to": "/claimFlow"
    }
  }, [_vm._v("查看详情")])], 1), _vm._v(" "), _c('p', {
    staticClass: "bb"
  }, [_vm._v("索赔资料:"), _c('router-link', {
    attrs: {
      "to": "/docs"
    }
  }, [_vm._v("查看详情")])], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.obj.status == 2) ? _c('div', {
    attrs: {
      "id": "claimSuccessPage"
    }
  }, [_c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("索赔人:"), _c('span', {
    attrs: {
      "id": "username"
    }
  }, [_vm._v(_vm._s(_vm.obj.u_name))])]), _vm._v(" "), _c('p', {
    staticClass: "bb"
  }, [_vm._v("索赔金额:"), _c('span', {
    attrs: {
      "id": "price"
    }
  }, [_vm._v("￥" + _vm._s(_vm.obj.price))])]), _vm._v(" "), _c('p', [_vm._v("银行卡号:"), _c('span', {
    attrs: {
      "id": "bankCard"
    }
  }, [_vm._v(_vm._s(_vm.obj.bank_card))])])]), _vm._v(" "), _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("索赔开始时间:"), _c('span', {
    attrs: {
      "id": "startDate"
    }
  }, [_vm._v(_vm._s(_vm.obj.start_ts))])]), _vm._v(" "), _c('p', [_vm._v("索赔结束时间:"), _c('span', {
    attrs: {
      "id": "endDate"
    }
  }, [_vm._v(_vm._s(_vm.obj.end_ts))])])]), _vm._v(" "), _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    attrs: {
      "id": "reason"
    }
  }, [_c('span', {
    staticStyle: {
      "position": "static"
    }
  }, [_vm._v("备注:" + _vm._s(_vm.obj.reason))])])])]) : _vm._e(), _vm._v(" "), (_vm.obj.status == 3) ? _c('div', {
    attrs: {
      "id": "claimFailedPage"
    }
  }, [_c('div', {
    staticClass: "block clearfix"
  }, [_c('p', [_vm._v("索赔人:"), _c('span', {
    attrs: {
      "id": "username"
    }
  }, [_vm._v(_vm._s(_vm.obj.u_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("索赔开始时间:"), _c('span', {
    attrs: {
      "id": "startDate"
    }
  }, [_vm._v(_vm._s(_vm.obj.start_ts))])]), _vm._v(" "), _c('p', [_vm._v("索赔结束时间:"), _c('span', {
    attrs: {
      "id": "endDate"
    }
  }, [_vm._v(_vm._s(_vm.obj.end_ts))])])]), _vm._v(" "), _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    attrs: {
      "id": "reason"
    }
  }, [_c('span', {
    staticStyle: {
      "position": "static"
    }
  }, [_vm._v("备注:" + _vm._s(_vm.obj.reason))])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "zhongan"
  }, [_vm._v("WiFi安全险"), _c('img', {
    attrs: {
      "src": require("../images/zhongan.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("每一用户单日/单次索赔限额："), _c('span', [_vm._v("￥20,000元")])]), _vm._v(" "), _c('p', [_vm._v("每一用户累计最高可赔："), _c('span', [_vm._v("￥100,000元")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("服务热线:"), _c('a', {
    attrs: {
      "href": "tel:4009999595"
    }
  }, [_vm._v("400-999-9595")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("索赔资料收件人:"), _c('span', {
    staticClass: "small_font"
  }, [_vm._v("WiFi万能钥匙用户安全理赔项目组")])]), _vm._v(" "), _c('p', {
    staticClass: "bb"
  }, [_vm._v("寄送地址:"), _c('span', {
    staticClass: "small_font"
  }, [_vm._v("上海市浦东新区张衡路666弄1号楼7楼")])]), _vm._v(" "), _c('p', [_vm._v("快递联系电话:"), _c('span', [_vm._v("400-035-8000")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5132ac15"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/claimDetail.vue
// module id = 826
// module chunks = 1